import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-eaadad12"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "AppPreloader__Background absolute inset-0 bg-black" }, null, -1));
const _hoisted_2 = { class: "Title text-mobile-display-2 lg:text-desktop-display-2 !tracking-wide lg:!tracking-wider whitespace-nowrap opacity-5" };
const _hoisted_3 = { class: "Animation__Container absolute" };
const _hoisted_4 = { class: "inline-grid items-end *:row-start-1 *:col-start-1" };
import { computed, onMounted, ref, watch } from "vue";
import { SplitText } from "gsap/SplitText";
import AudioManager from "@webgl/core/audio/AudioManager";
import { useAppState } from "@/services/Composition";
import useGSAP from "@/composables/useGSAP";
import Viewport from "@/store/modules/Viewport";
import { PRELOADER_MIN_DURATION } from "@/config/constants";
import { setFPS } from "@/utils/frameToTime";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppPreloader',
    setup(__props) {
        const gsap = useGSAP();
        const frames = setFPS(60);
        const { state, send } = useAppState();
        const root = ref(null);
        const progress = ref(0);
        const isLoaded = ref(false);
        const isAppReady = ref(false);
        const showEnterCTA = computed(() => state.value.matches("loaded"));
        const canClose = computed(() => isAppReady.value && showEnterCTA.value);
        watch([isLoaded, showEnterCTA], ([isLoaded, showEnterCTA]) => {
            if (isLoaded && showEnterCTA) {
                isAppReady.value = true;
            }
        });
        const close = () => {
            AudioManager.playUI("UI_CLICK");
            send("NEXT");
        };
        function onEnter(el, onComplete) {
            const $ = gsap.utils.selector(el);
            const tl = gsap.timeline({ onComplete });
            // Heading in background
            tl.add((() => {
                const [el] = $(".Title");
                const title = new SplitText(el, { type: "chars" });
                const stagger = frames(10);
                const getDelay = (index) => {
                    const orders = [[0, 3, 4, 1], [6, 2, 5]];
                    let chunkIndex = 0;
                    let inChunkIndex = 0;
                    for (let i = 0; i < orders.length; i++) {
                        const chunk = orders[i];
                        inChunkIndex = chunk.indexOf(index);
                        if (inChunkIndex !== -1) {
                            chunkIndex = i;
                            break;
                        }
                    }
                    ;
                    return Math.max(0, inChunkIndex) * stagger + chunkIndex * 3 * stagger;
                };
                gsap.set(title.chars, { opacity: 1 });
                return gsap.to(title.chars, {
                    keyframes: {
                        "0%": { opacity: 1 },
                        "6.896552%": { opacity: 0.6 },
                        "10.344828%": { opacity: 0.6 },
                        "31.034483%": { opacity: 1 },
                        "34.482759%": { opacity: 1 },
                        "41.37931%": { opacity: 0.6 },
                        "44.827586%": { opacity: 0.6 },
                        "65.517241%": { opacity: 1 },
                        "68.965517%": { opacity: 1 },
                        "75.862069%": { opacity: 0.6 },
                        "79.310345%": { opacity: 0.6 },
                        "100%": { opacity: 0, ease: "ease.out" },
                        easeEach: "none"
                    },
                    duration: frames(290),
                    ease: "none",
                    stagger: getDelay
                });
            })(), 0);
        }
        function onLeave(el, onComplete) {
            const $ = gsap.utils.selector(el);
            const tl = gsap.timeline({ onComplete });
            const [exitTarget] = $(".WindowExit");
            const [animation] = $(".AppPreloaderAnimation");
            const { width, height } = exitTarget.getBoundingClientRect();
            // compute min scale
            const scale = Math.max(Viewport.windowWidth / width, Viewport.windowHeight / height);
            tl
                .to(animation, {
                scale,
                duration: frames(120),
                ease: "quart.inOut"
            })
                .to(animation, {
                opacity: 0,
                duration: frames(110),
                ease: "ease.out"
            }, "<")
                .set($(".AppPreloader__Background"), { opacity: 0 }, 0)
                .to($(".AppPreloader__UI"), {
                opacity: 0,
                duration: frames(30),
                ease: "ease.out"
            }, 0);
        }
        watch([isLoaded, showEnterCTA], ([isLoaded, showEnterCTA]) => {
            if (isLoaded && showEnterCTA) {
                isAppReady.value = true;
            }
        });
        onMounted(() => {
            if (!root.value)
                return;
            gsap.to(progress, {
                value: 100,
                snap: "value",
                duration: PRELOADER_MIN_DURATION / 1000,
                ease: "quad.inOut",
                onComplete: () => {
                    isLoaded.value = true;
                }
            });
        });
        return (_ctx, _cache) => {
            const _component_AppPreloaderAnimation = _resolveComponent("AppPreloaderAnimation");
            const _component_UIBtn = _resolveComponent("UIBtn");
            return (_openBlock(), _createBlock(_Transition, {
                css: false,
                appear: "",
                onEnter: onEnter,
                onLeave: onLeave
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        ref_key: "root",
                        ref: root,
                        class: "AppPreloader absolute inset-0 flex justify-center items-center text-white overflow-hidden"
                    }, [
                        _hoisted_1,
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("preloader.title")), 1),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_AppPreloaderAnimation, { class: "Animation" })
                        ]),
                        _createElementVNode("div", {
                            class: _normalizeClass(["AppPreloader__UI absolute inset-0 flex flex-col-reverse items-center gap-32 p-20 lg:p-40 *:pointer-events-none", { 'pointer-events-none': !canClose.value }]),
                            onClick: close
                        }, [
                            _createElementVNode("span", _hoisted_4, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(["text-desktop-cap text-center text-balance transition-opacity duration-500 delay-300 ease-out", { 'opacity-0': !isAppReady.value }])
                                }, _toDisplayString(_ctx.$t("preloader.sound_hint")), 3),
                                _createElementVNode("span", {
                                    class: _normalizeClass(["Progress text-desktop-cap text-center transition-opacity duration-500 ease-out", { 'opacity-0': isAppReady.value }])
                                }, _toDisplayString(progress.value) + "% ", 3)
                            ]),
                            (_unref(Viewport).isTouch)
                                ? _withDirectives((_openBlock(), _createBlock(_component_UIBtn, {
                                    key: 0,
                                    as: "span",
                                    class: "",
                                    variant: "solid",
                                    theme: "light"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("preloader.cta")), 1)
                                    ]),
                                    _: 1
                                }, 512)), [
                                    [_vShow, canClose.value]
                                ])
                                : _createCommentVNode("", true)
                        ], 2)
                    ], 512)
                ]),
                _: 1
            }));
        };
    }
});
